var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRapport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1728",
    "data-name": "Rectangle 1728",
    width: 18.632,
    height: 11.635,
    fill: "#eff3fa"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stage_4:_Rapport",
    "data-name": "Stage 4: Rapport",
    transform: "translate(-593 -302.662)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_683",
    "data-name": "Ellipse 683",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(593 302.662)",
    fill: "#ee3d4b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_32057",
    "data-name": "Group 32057",
    transform: "translate(597.684 310.845)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32056",
    "data-name": "Group 32056",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13522",
    "data-name": "Path 13522",
    d: "M9.686,3.375a3.058,3.058,0,0,0-1.445.885c-1.12.746-1.826.426-2.084.253A1.579,1.579,0,0,1,6,2.433.421.421,0,0,1,6.05,2.35c.206-.284.355-.492.48-.663H3.976a.538.538,0,0,1-.53-.454A1.288,1.288,0,0,0,3.31.856,1.23,1.23,0,0,0,2.6.3,9.59,9.59,0,0,0,.12,0L0,.142V6.825l.139.141H.993a1.167,1.167,0,0,0,.712-.235A1.4,1.4,0,0,0,2.077,6.3a.532.532,0,0,1,.408-.257h.052a.532.532,0,0,1,.4.18,39.965,39.965,0,0,0,6.079,5.322.4.4,0,0,0,.532-.03c.024-.025.024-.053.04-.079L7.223,9.065a.538.538,0,0,1,.764-.756l2.569,2.581a.564.564,0,0,0,.16.059.743.743,0,0,0,.473-.167.5.5,0,0,0,.079-.172L8.911,8.24a.536.536,0,1,1,.732-.783.329.329,0,0,1,.027.027L12.2,10.029a.6.6,0,0,0,.7-.1.561.561,0,0,0,.088-.227L10.554,7.242a.536.536,0,1,1,.732-.783.329.329,0,0,1,.027.027l2.569,2.581a.654.654,0,0,0,.595-.123.531.531,0,0,0,.155-.383.487.487,0,0,0-.03-.138c-.527-.544-4.2-4.319-4.916-5.059",
    transform: "translate(0 0)",
    fill: "#eff3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13523",
    "data-name": "Path 13523",
    d: "M18.3.868a11.161,11.161,0,0,0-2.837.29,1.125,1.125,0,0,0-.731.579,1.073,1.073,0,0,0-.108.3A.538.538,0,0,1,14,2.474a.533.533,0,0,1-.105-.03L9.916.858A1.071,1.071,0,0,0,9.252.812a4.064,4.064,0,0,0-1.417.73A7.624,7.624,0,0,0,6.727,2.916a.96.96,0,0,0-.164.684.885.885,0,0,0,.78-.191A3.676,3.676,0,0,1,9.55,2.258h.008a.765.765,0,0,1,.564.217c3.271,3.362,4.459,4.585,4.9,5.033a1.574,1.574,0,0,0,.42-.377.5.5,0,0,1,.454-.206.544.544,0,0,1,.43.26,1.338,1.338,0,0,0,.353.389,1.2,1.2,0,0,0,.681.216h.923l.139-.141V.966L18.355.889a.087.087,0,0,0-.061-.022",
    transform: "translate(0.212 0.025)",
    fill: "#eff3fa"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRapport);
export default __webpack_public_path__ + "static/media/rapport.0c620fecc0c4d973172ddefb6ba13b80.svg";
export { ForwardRef as ReactComponent };